import React from 'react'
import { subscribe } from 'react-contextual'
import { ListingTemplate } from '../../../views/components'
import { useEffectOnce } from 'react-use'
import { useDispatch } from 'react-redux'
import { SuspenseAccountsSearchFilter, SuspenseAccountsTable } from '..'
import SuspenseAccountsProvider from '../SuspenseAccountsProvider'
import { reportingApiEvents } from 'modules/api/reporting'

function SuspenseAccountsContent({ isLoading }: any) {
  const dispatch = useDispatch()
  useEffectOnce(() => {
    dispatch(reportingApiEvents.suspenseAccountStats_request())
    dispatch(reportingApiEvents.suspenseAccountList_request({ list: 'unallocated' }))
    dispatch(reportingApiEvents.suspenseAccountList_request({ list: 'allocated' }))
  })

  return (
    <ListingTemplate loading={isLoading} Header={<SuspenseAccountsSearchFilter />} Body={<SuspenseAccountsTable />} />
  )
}

export default subscribe([SuspenseAccountsProvider], ({ isLoading }: any) => ({
  isLoading,
}))(SuspenseAccountsContent)
